import { createTheme } from "@commonlibs";
import { lightPalette, borderSm, borderMd, otpBorder } from "./palette/lightPalette";
import baseTheme from "./baseTheme";

const lightTheme = createTheme({
    ...baseTheme,
    palette: lightPalette,
    border: {
        sm: borderSm,
        md: borderMd,
        otp: otpBorder
    },
});

export default lightTheme;
